import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Registrar service worker para PWA instalable en Android/iOS
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Actualización automática: al volver a la app (o cada 10 min sin formulario abierto),
// si hay una versión nueva publicada se recarga sola. Así nadie tiene que cerrar la app.
const loadedMain = [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\.[^/]+\.js/.test(s));
const checkForUpdate = async (onlyIfIdle) => {
  if (!loadedMain) return;
  if (onlyIfIdle && document.activeElement && ["INPUT", "TEXTAREA", "SELECT"].includes(document.activeElement.tagName)) return;
  try {
    const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
    const latest = html.match(/\/static\/js\/main\.[^"']+\.js/);
    if (latest && !loadedMain.includes(latest[0])) window.location.reload();
  } catch { /* sin red: se intenta más tarde */ }
};
document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") checkForUpdate(false); });
setInterval(() => { if (document.visibilityState === "visible") checkForUpdate(true); }, 10 * 60 * 1000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
